import React from 'react';
import { AddressLink } from '../../../common/components/table/cellRenderers/AddressLink';
import { colSettings } from "../../../common/components/table/agGrid/colSettings";
import { marketDynamicsColumns as mdCols } from "../marketDynamicsColumns";
import { drillDownRoutesByModule, moduleNames } from '../../../constants';

export const initialCommonColumns = [
    { col: mdCols.mlsNum, colDef: colSettings.textSmall },
    { col: mdCols.typeName, colDef: colSettings.textSmall },
    {
        col: mdCols.address,
        colDef: colSettings.textMd,
        cellRenderer: (props) => (
            <AddressLink {...props} pathname={`${drillDownRoutesByModule[moduleNames.marketDynamics].listingInfo}`}/>
        ),
    },
    { col: mdCols.city, colDef: colSettings.textMd },
    { col: mdCols.zipcode, colDef: colSettings.textSmall },
    { col: mdCols.areaId, colDef: colSettings.textSmall },
    { col: mdCols.orgPrice, colDef: colSettings.numberSmVolume },
];

export const getFinalCommonColumns = (shouldShowAdditionalInfoCols) => [
    { col: mdCols.dom, colDef: colSettings.blankEmptyXsInteger },
    { col: mdCols.cdom, colDef: colSettings.blankEmptyXsInteger },
    { col: mdCols.bankStatus, colDef: colSettings.bankStatus },
    ...(shouldShowAdditionalInfoCols ? additionalInformationColumns: []),
    { col: mdCols.listAgent, colDef: colSettings.textMd },
];

export const additionalInformationColumns = [
    { col: mdCols.priceChangeCnt, colDef: colSettings.numberLgInteger },
    { col: mdCols.bedrooms, colDef: colSettings.numberXsInteger },
    { col: mdCols.fullBaths, colDef: colSettings.numberXsInteger },
    { col: mdCols.squareFt, colDef: colSettings.numberXsInteger },
    { col: mdCols.costPerSqft, colDef: colSettings.numberXsVolume },
    { col: mdCols.lotSizeSquareFt, colDef: colSettings.numberSmInteger },
    { col: mdCols.yearBuilt, colDef: colSettings.numberSmRightAlign },
];
